import { render, staticRenderFns } from "./Kgraphpanel.vue?vue&type=template&id=848bf65e"
import script from "./Kgraphpanel.vue?vue&type=script&lang=js"
export * from "./Kgraphpanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports